// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__se1yC","label":"styles_label__2a5-l"};